import React from 'react';
import { motion } from 'framer-motion';
import { PORTFOLIO_CATEGORIES } from '../data/portfolioData';

const PortfolioFilter = ({ activeCategory, onCategoryChange }) => {
  const filterVariants = {
    hidden: { opacity: 0, y: -20 },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.5,
        staggerChildren: 0.1
      }
    }
  };

  const itemVariants = {
    hidden: { opacity: 0, y: -10 },
    visible: { opacity: 1, y: 0 }
  };

  return (
    <motion.div
      variants={filterVariants}
      initial="hidden"
      animate="visible"
      className="flex flex-wrap justify-center gap-3 mb-12"
    >
      {Object.entries(PORTFOLIO_CATEGORIES).map(([key, label]) => (
        <motion.button
          key={key}
          variants={itemVariants}
          onClick={() => onCategoryChange(key)}
          whileHover={{ scale: 1.05 }}
          whileTap={{ scale: 0.95 }}
          className={`
            px-6 py-2 rounded-full font-medium text-sm transition-all duration-300
            ${activeCategory === key
              ? 'bg-primary text-primary-foreground shadow-lg'
              : 'bg-secondary text-secondary-foreground hover:bg-secondary/80'
            }
          `}
        >
          {label}
        </motion.button>
      ))}
    </motion.div>
  );
};

export default PortfolioFilter;